import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';

import { RouteName } from '@app/router/constants/RouteName';

import { VirtualTournament } from '@sportOfferFederation/competitions/types';
import { ExpandedEventInUrl } from '@src/app/enums';

export function useHotTournamentCompetitionRedirect() {
    const { pushRoute } = useVueRouter();

    function redirectToCompetition(hotTournament: VirtualTournament): void {
        pushRoute({
            name: RouteName.Sport.TournamentRedirect,
            params: {
                id: hotTournament.childrenIds.join(','),
            },
            query: {
                [ExpandedEventInUrl.competitionId]: hotTournament.competitionId?.toString(),
                [ExpandedEventInUrl.competitionTab]: hotTournament.competitionTab,
                [ExpandedEventInUrl.marketGroup]: hotTournament.marketGroupId?.toString(),
            },
        });
    }

    return {
        redirectToCompetition,
    };
}
